import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { User } from "../../user/user.model";
import { RoleMenuItem, NavigationService } from "../nav/navigation.service";
import { NotifyService } from "../../notify/notify.service";
import { noop } from "../../shared/noop.function";
import { UserRepository } from "../../user/user.repository";
import { role } from "../../user/role.const";
import { LocalStorageProvider } from "../../shared/storage-provider/local-storage-provider";
import { NgxPermissionsService } from "ngx-permissions";
import { Router, RouterLink } from "@angular/router";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrls: ["./user-menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink],
})
export class UserMenuComponent implements OnInit, OnDestroy {
  private navigationService = inject(NavigationService);
  private userRepository = inject(UserRepository);
  private notifyService = inject(NotifyService);
  private permissionService = inject(NgxPermissionsService);
  private router = inject(Router);
  private elementRef = inject(ElementRef);

  @Input() public user: User;
  public storage = new LocalStorageProvider();
  public userDropdownOptions: RoleMenuItem[] = [];
  public subscription = new Subscription();
  // Touch has no hover: the trigger toggles the panel, a tap anywhere else
  // closes it. Desktop keeps the hover rule in the stylesheet on top of this.
  public isOpen = false;

  @HostListener("document:click", ["$event"])
  public onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (
      !this.elementRef.nativeElement.contains(target) ||
      target.closest(".user-menu__item")
    ) {
      this.isOpen = false;
    }
  }

  public toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
    this.buildDropdown();
    this.handleImpersonateMode();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public callMethod(method: string): void {
    if (this[method]) {
      this[method]();
    }
  }

  public buildDropdown() {
    this.userDropdownOptions = [];

    this.subscription.add(
      this.navigationService.getUserDropdownOptions().subscribe((items) => {
        items.forEach((item, itmIdx) => {
          items[itmIdx].visible = this.navigationService.setVisibleIfRole(
            this.user,
            item,
          );
        });

        this.userDropdownOptions = items;
      }),
    );
  }

  public openProfile() {
    this.userRepository.getUser().subscribe({
      next: (user) => {
        this.router.navigate([`user/${user.getId()}`]);
      },
      error: noop,
    });
  }

  public handleImpersonateMode() {
    if (
      !!this.storage.get("impersonate") &&
      !this.user.hasRole(role.previousAdmin)
    ) {
      this.user.setRoles([...this.user.getRoles(), role.previousAdmin]);
      this.permissionService.flushPermissions();
      this.permissionService.loadPermissions(this.user.getRoles());

      this.buildDropdown();
    }
  }
}
